import { FastlyImageParams, serialiseFastlyParams } from './fastly-image-params';

const FALLBACK_PARAMS: FastlyImageParams = { quality: 65, format: 'auto' };
export const FALLBACK_PRESET = serialiseFastlyParams(FALLBACK_PARAMS);
const AVATAR_LANDSCAPE_PRESET: FastlyImageParams = { width: 288, height: 216, quality: 95, format: 'auto', crop: { smart: true } };
const AVATAR_LARGE_PRESET: FastlyImageParams = { width: 480, height: 480, quality: 95, format: 'auto', crop: { smart: true } };
const AVATAR_STANDARD_PRESET: FastlyImageParams = { width: 200, height: 200, quality: 95, format: 'auto', crop: { smart: true } };
const CAMPAIGN_DEFAULT_PRESET: FastlyImageParams = { width: 530, height: 400, quality: 85, format: 'auto', fit: 'crop' };
const CAMPAIGN_SMALL_PRESET: FastlyImageParams = { width: 340, height: 255, quality: 65, format: 'auto', fit: 'crop' };
const CAMPAIGN_TINY_PRESET: FastlyImageParams = { width: 96, height: 64, format: 'auto', fit: 'crop' };
const DEFAULT_DESKTOP_TILE_PRESET: FastlyImageParams = { width: 900, height: 600, quality: 65, format: 'auto', fit: 'bounds' };
const DEFAULT_MOBILE_TILE_PRESET: FastlyImageParams = { width: 530, height: 400, quality: 65, format: 'auto', fit: 'crop' };
const DEFAULT_TILE_PRESET: FastlyImageParams = { width: 340, height: 255, quality: 65, format: 'auto', fit: 'crop' };
const FLOOR_PLAN_GALLERY_PRESET: FastlyImageParams = { width: 423, height: 240, quality: 65, format: 'auto', fit: 'bounds' };
const FLOOR_PLAN_MODAL_PRESET: FastlyImageParams = { width: 768, height: 1024, quality: 65, format: 'auto', fit: 'bounds' };
const IMAGE_RESIZE_CAMPAIGN_THUMBNAIL_PRESET: FastlyImageParams = {
  width: 120,
  height: 80,
  quality: 75,
  format: 'auto',
  crop: { smart: true },
};
const PAGE_META_THUMBNAIL_PRESET: FastlyImageParams = { width: 800, height: 500, quality: 75, format: 'auto', crop: { smart: true } };
const PAGE_META_THUMBNAIL_LARGE_PRESET: FastlyImageParams = { width: 1140, height: 900, quality: 75, format: 'auto', fit: 'crop' };
const PROFILE_BANNER_LOGO_PRESET: FastlyImageParams = { height: 80, quality: 95, format: 'auto', fit: 'bounds' };
const PROFILE_COVER_PRESET: FastlyImageParams = { width: 955, height: 200, quality: 99, format: 'auto', fit: 'crop' };
const SQUARE_200_PRESET: FastlyImageParams = { width: 200, height: 200, quality: 95, format: 'auto', crop: { smart: true } };
const SQUARE_150_PRESET: FastlyImageParams = { width: 150, height: 150, quality: 95, format: 'auto', crop: { smart: true } };
const PROFILE_GALLERY_PRESET: FastlyImageParams = { width: 220, height: 192, quality: 95, format: 'auto', fit: 'crop' };
const SQUARE_180_PRESET: FastlyImageParams = { width: 180, height: 180, quality: 85, format: 'auto', fit: 'bounds' };
const CAMPAIGN_GALLERY_HERO_PRESET: FastlyImageParams = { width: 774, height: 416, quality: 75, format: 'auto', crop: { smart: true } };

// Each microsite preset is twice its CSS box so it stays sharp on a 2x display.
// FastlyImageParams has no crop offset, so the team photo crops from the centre even though
// heads sit high in a group shot.
const MICROSITE_AVATAR_PRESET: FastlyImageParams = { width: 88, height: 88, quality: 85, format: 'auto', crop: { smart: true } };
const MICROSITE_BRAND_TILE_PRESET: FastlyImageParams = { height: 320, quality: 85, format: 'auto', fit: 'bounds' };
const MICROSITE_HERO_PORTRAIT_PRESET: FastlyImageParams = { width: 780, height: 780, quality: 85, format: 'auto', crop: { smart: true } };
const MICROSITE_PORTRAIT_PRESET: FastlyImageParams = { width: 300, height: 300, quality: 85, format: 'auto', crop: { smart: true } };
const MICROSITE_PROPERTY_TILE_PRESET: FastlyImageParams = { width: 736, height: 480, quality: 85, format: 'auto', fit: 'crop' };
const MICROSITE_REVIEW_CAP_PRESET: FastlyImageParams = { width: 600, height: 300, quality: 85, format: 'auto', fit: 'crop' };
const MICROSITE_ROSTER_PORTRAIT_PRESET: FastlyImageParams = { width: 168, height: 168, quality: 85, format: 'auto', crop: { smart: true } };
const MICROSITE_TEAM_PHOTO_PRESET: FastlyImageParams = { width: 780, height: 428, quality: 85, format: 'auto', fit: 'crop' };

export const IMAGE_OPTIMISE_PRESETS = {
  AvatarLandscape: AVATAR_LANDSCAPE_PRESET,
  AvatarLarge: AVATAR_LARGE_PRESET,
  AvatarStandard: AVATAR_STANDARD_PRESET,
  CampaignDefault: CAMPAIGN_DEFAULT_PRESET,
  CampaignSmall: CAMPAIGN_SMALL_PRESET,
  CampaignGalleryHero: CAMPAIGN_GALLERY_HERO_PRESET,
  CampaignThumbnail: IMAGE_RESIZE_CAMPAIGN_THUMBNAIL_PRESET,
  CampaignTiny: CAMPAIGN_TINY_PRESET,
  DefaultDesktopTile: DEFAULT_DESKTOP_TILE_PRESET,
  DefaultMobileTile: DEFAULT_MOBILE_TILE_PRESET,
  DefaultTile: DEFAULT_TILE_PRESET,
  Fallback: FALLBACK_PARAMS,
  FloorPlanGallery: FLOOR_PLAN_GALLERY_PRESET,
  FloorPlanModal: FLOOR_PLAN_MODAL_PRESET,
  MicrositeAvatar: MICROSITE_AVATAR_PRESET,
  MicrositeBrandTile: MICROSITE_BRAND_TILE_PRESET,
  MicrositeHeroPortrait: MICROSITE_HERO_PORTRAIT_PRESET,
  MicrositePortrait: MICROSITE_PORTRAIT_PRESET,
  MicrositePropertyTile: MICROSITE_PROPERTY_TILE_PRESET,
  MicrositeReviewCap: MICROSITE_REVIEW_CAP_PRESET,
  MicrositeRosterPortrait: MICROSITE_ROSTER_PORTRAIT_PRESET,
  MicrositeTeamPhoto: MICROSITE_TEAM_PHOTO_PRESET,
  PageMetaThumbnail: PAGE_META_THUMBNAIL_PRESET,
  PageMetaLargeThumbnail: PAGE_META_THUMBNAIL_LARGE_PRESET,
  ProfileBannerLogo: PROFILE_BANNER_LOGO_PRESET,
  ProfileCover: PROFILE_COVER_PRESET,
  ProfileGallery: PROFILE_GALLERY_PRESET,
  Square150: SQUARE_150_PRESET,
  Square180: SQUARE_180_PRESET,
  Square200: SQUARE_200_PRESET,
} as const;

export type ImageOptimisePreset = keyof typeof IMAGE_OPTIMISE_PRESETS;
export const mapImagePresetKeyToConfig = (p: ImageOptimisePreset): string => serialiseFastlyParams(IMAGE_OPTIMISE_PRESETS[p]);

/**
 * Serialises a preset at another width, for a `srcset`. Quality, format, fit and crop are kept,
 * and the height scales to keep the preset's aspect ratio. A preset with no width is returned
 * unchanged.
 */
export const mapImagePresetKeyToConfigAtWidth = (p: ImageOptimisePreset, width: number): string => {
  const preset = IMAGE_OPTIMISE_PRESETS[p];
  if (!preset.width) {
    return serialiseFastlyParams(preset);
  }
  const scaled: FastlyImageParams = { ...preset, width };
  if (preset.height) {
    scaled.height = Math.round((preset.height / preset.width) * width);
  }
  return serialiseFastlyParams(scaled);
};

export function isImagePresetKey(k: string): k is ImageOptimisePreset {
  return Object.keys(IMAGE_OPTIMISE_PRESETS).includes(k);
}
